import { settings } from '@pixi/core';
export { settings } from '@pixi/core';

settings.MESH_CANVAS_PADDING = 0;
//# sourceMappingURL=settings.mjs.map
